<div class="main-class position-relative">
  <div class="container">
    <nav class="navbar navbar-expand-lg navbar-light bg-transparent">
      <a class="navbar-brand" (click)="navigate()">
        <img src="../../assets/automapai-logo.png" class="header-termhub-logo" alt="AutomapAI" />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarTogglerDemo03"
        aria-controls="navbarTogglerDemo03"
        aria-expanded="false"
        aria-label="Toggle navigation"
        id="toggleNavBtn"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarTogglerDemo03">
        <div class="ml-auto header-search"></div>
        <div class="btns">
          <app-button class="log_in" btnType="landing-outline" type="submit" [routerLink]="'/login'">Log In</app-button>
          <app-button class="sign_up" btnType="landing" type="submit" [routerLink]="'/signup'">Sign Up</app-button>
        </div>
      </div>
    </nav>
    <div class="inner-section">
      <div class="row m-0">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-7 col-xl-7">
          <div class="section-heading">
            <h1>The natural evolution of terminology tooling... Terminology as a Service</h1>
          </div>
          <div class="section-body">
            <p>
              AutomapAI is a high-performance, scalable, cloud-based, solution for managing access to standard healthcare terminologies. Create projects
              that include combinations of terminologies and versions for a variety of different use cases in minutes. Browse, access through unified
              APIs (including FHIR), perform semantic searching, and visualize content in a variety of different ways. This system includes automatic
              updating for "always current" access to national standards as well as "on demand" updating to new versions when you need them. Make all
              of your Terminology dreams come true.
            </p>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5 col-xl-5"></div>
      </div>
    </div>
  </div>
</div>
